import React from 'react';
import { Redirect } from 'react-router-dom';
import { RootUri } from './routes';

export const Home = (): JSX.Element => <Redirect to={RootUri} />;
